import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Container, Row } from 'react-bootstrap';
import Button from '../Button';
import CalloutCard from './CalloutCard';

const buttons = [
  <Button
    variant="secondary-outline"
    rightIcon={light('user-doctor')}
    className="callout-button"
    size="sm"
  >
    Find a Provider
  </Button>,
  <Button
    variant="secondary-outline"
    rightIcon={light('scale-balanced')}
    className="callout-button"
    size="sm"
  >
    Compare Plans
  </Button>,
];
const buttons1 = [
  <Button
    variant="secondary-outline"
    rightIcon={light('user-doctor')}
    className="callout-button"
    size="sm"
  >
    Find a Provider
  </Button>,
];

const CalloutCardDemo = () => {
  return (
    <Container>
      <Container className="mt-10">
        <h4>Callout Card</h4>
        <Container className="pb-10">
          <CalloutCard cardIcon={light('screwdriver-wrench')} buttons={buttons}>
            <Row className='content-row'>
              <span className="bolder-text">
                Would you like to explore your plan options in more detail?
              </span>
              <p>
                <span className="bolder-text">Compare Plans</span> to check
                coverage levels, costs and what plan is best for you and your
                family
              </p>
              <p>
                <span className="bolder-text">Find a provider</span> to see if
                your doctor is included in your available plans.
              </p>
            </Row>
          </CalloutCard>
        </Container>
        <Container>
          <CalloutCard
            cardIcon={light('screwdriver-wrench')}
            buttons={buttons1}
          >
            <Row>
              <span className="bolder-text">
                Would you like to explore your plan options in more detail?
              </span>
              <p>
                <span className="bolder-text">Compare Plans</span> to check
                coverage levels, costs and what plan is best for you and your
                family
              </p>
              <p>
                <span className="bolder-text">Find a provider</span> to see if
                your doctor is included in your available plans.
              </p>
            </Row>
          </CalloutCard>
        </Container>
      </Container>
    </Container>
  );
};

export default CalloutCardDemo;
